import OrganizationView from './containers/OrganizationView.jsx';

export default OrganizationView;
